import React, { useState } from 'react';
import Recaptcha from 'react-google-recaptcha';

import '../styles.scss';
import './styles.scss';
import services from '../../../services';
import { trackPromise } from 'react-promise-tracker';

import { useDispatch } from 'react-redux';
import {
  //showMsgW as showMsgWAction,
  showMsgE as showMsgEAction,
  //showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import Modal from '../../../components/Modal/Modal';

import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { useRef } from 'react';
import globals from '../../../globals';
import { validaEmail } from '../../../services/validaEmail.js';
import DOMPurify from 'dompurify';

const sanitizeInput = (inputData) => {
  return DOMPurify.sanitize(inputData);
};

const RECAPTCHA_KEY = globals.REACT_APP_RECAPTCHA_KEY;

const FormRecuperarSenha = ({ modalStatus, setModalStatus }) => {
  const dispatch = useDispatch();
  const recaptcha = useRef(null);
  //const showMsgW = (msg) => dispatch(showMsgWAction(msg));
  const showMsgE = (msg) => dispatch(showMsgEAction(msg));
  //const showMsgS = (msg) => dispatch(showMsgSAction(msg));

  const [email, setEmail] = useState('');

  const concluir = () => {
    setModalStatus({
      ...modalStatus,
      esqueciSenha: false,
      conclusaoEsqueciSenha: true,
    });
  };

  const recuperarSenha = () => {
    if (email === null) {
      return;
    }
    sendAuto();
  };

  // const sendAuto = () => {
  //     trackPromise (
  //         services.apiAuto.resetarSenha({email: email})
  //         .then(res => {
  //             if (!res.fail) {
  //                 concluir();
  //             }
  //         })
  //     )
  // }

  const sendAuto = () => {
    if (recaptcha.current) {
      trackPromise(
        recaptcha.current
          .executeAsync()
          .then((recaptchaToken) => {
            services.storage.set('captcha', recaptchaToken);
            services.apiAuto.resetarSenha({ email: email }).then((res) => {
              if (!res.fail) {
                concluir();
              } else if (res.fail) {
                if (res.errors?.message) showMsgE(res.errors.message);
                else showMsgE('Não foi possível resetar a senha!');
              }
            });
          })
          .catch((error) => {
            console.log(error);
          })
      );
    }
  };
  return (
    <Modal
      open={modalStatus.esqueciSenha}
      close={() => {
        setModalStatus({ ...modalStatus, esqueciSenha: false });
      }}
      size="lg"
    >
      <div className="pageBody FormRecuperarSenha">
        <div className="container-fluid">
          <h2>Informe seu e-mail cadastrado para receber a nova senha</h2>
          <FormControl>
            <TextField
              label="E-mail"
              type="text"
              className="inputCustom"
              size="small"
              value={email}
              inputProps={{ maxLength: 100 }}
              onChange={(event) => setEmail(sanitizeInput(event.target.value))}
              variant="filled"
            />
            <div className="avisoCampo">
              {!validaEmail(email) && email.length >= 1
                ? 'Inserir e-mail valido'
                : ' '}
            </div>
          </FormControl>
          <Recaptcha ref={recaptcha} sitekey={RECAPTCHA_KEY} size="invisible" />
          <button
            className="btn btn-dark btn-block btn-lg mt20 buttonCustom"
            onClick={recuperarSenha}
            disabled={!validaEmail(email)}
          >
            Resetar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FormRecuperarSenha;
